import React from "react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
export function FinalCTA() {
  return <section className="px-4 py-16 sm:py-20" data-id="element-149" data-mp="5bz376lq07ki">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-150" data-mp="3mtrye73lgb1c">
        <h2 className="font-serif text-[1.85rem] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-151" data-mp="3mrnxzz4wlu5t">
          Ready to stop guessing and <em className="italic text-brand-600" data-id="element-152" data-mp="3dtbxn5e8ji06">start following a system?</em>
        </h2>
        <p className="mt-5 max-w-xl text-lg leading-relaxed text-muted" data-id="element-153" data-mp="3hup2pd9i7h61">
          The goal isn't to know every ECU procedure in the world. The goal is to have a process that moves you from:
        </p>
        <div className="mt-6 grid w-full max-w-xl gap-3 sm:grid-cols-2" data-id="element-154" data-mp="38tqyouz2f9ng">
          <p className="rounded-2xl bg-bad-light px-4 py-5 font-serif text-xl font-bold text-bad" data-id="element-155" data-mp="38w3gn84tpk0i">“I don't know what to do.”</p>
          <p className="rounded-2xl bg-cta-light px-4 py-5 font-serif text-xl font-bold text-cta-dark" data-id="element-156" data-mp="172dvcacqx9ti">“I know what I need to check next.”</p>
        </div>
        <p className="mt-8 text-sm font-bold uppercase text-brand-700" data-id="element-157" data-mp="q6snbb10pjvy">Only $27 USD</p>
        <CTAButton className="mt-3" label="Get access now" subtext="Instant download · Lifetime access · One-time payment · 7-day guarantee" data-id="element-158" data-mp="l90vsi4abzsa" />
        <div className="mt-8" data-id="element-159" data-mp="v0eoo71qe1cg">
          <Countdown data-id="element-160" data-mp="v058fb6hn8jy" />
        </div>
      </div>
    </section>;
}